import { useState, useCallback, useMemo } from "react";

const EMPTY_FILTERS = {
  gender: [],
  schoolType: [],
  localAuthority: [],
  catchmentCategory: [],
  ofstedRating: [],
  oxbridgeOffers: 0,
  examSubjects: [],

  // GCSE Results
  gcseGrade89: 0,
  gcseGrade79: 0,
  attainment8: 0,
  progress8: -1,
  engMath5: 0,
  ebaccEntry: 0,

  // A Level Results
  alevelAstar: 0,
  alevelAstarA: 0,
  alevelAAB: 0,
  alevelAPS: 0,
  alevelValueAdded: -1,

  // Location
  distanceMiles: 20,
};

function isRangeActive(val, defaultVal) {
  return val !== defaultVal;
}

export function useFilterState() {
  const [filters, setFilters] = useState(EMPTY_FILTERS);

  const updateFilter = useCallback((key, value) => {
    setFilters((prev) => ({ ...prev, [key]: value }));
  }, []);

  const resetFilters = useCallback(() => {
    setFilters(EMPTY_FILTERS);
  }, []);

  const hasActiveFilters = useMemo(() => {
    return (
      filters.gender.length > 0 ||
      filters.schoolType.length > 0 ||
      filters.localAuthority.length > 0 ||
      filters.catchmentCategory.length > 0 ||
      filters.ofstedRating.length > 0 ||
      filters.oxbridgeOffers > 0 ||
      filters.examSubjects.length > 0 ||
      isRangeActive(filters.gcseGrade89, EMPTY_FILTERS.gcseGrade89) ||
      isRangeActive(filters.gcseGrade79, EMPTY_FILTERS.gcseGrade79) ||
      isRangeActive(filters.attainment8, EMPTY_FILTERS.attainment8) ||
      isRangeActive(filters.progress8, EMPTY_FILTERS.progress8) ||
      isRangeActive(filters.engMath5, EMPTY_FILTERS.engMath5) ||
      isRangeActive(filters.ebaccEntry, EMPTY_FILTERS.ebaccEntry) ||
      isRangeActive(filters.alevelAstar, EMPTY_FILTERS.alevelAstar) ||
      isRangeActive(filters.alevelAstarA, EMPTY_FILTERS.alevelAstarA) ||
      isRangeActive(filters.alevelAAB, EMPTY_FILTERS.alevelAAB) ||
      isRangeActive(filters.alevelAPS, EMPTY_FILTERS.alevelAPS) ||
      isRangeActive(filters.alevelValueAdded, EMPTY_FILTERS.alevelValueAdded) ||
      isRangeActive(filters.distanceMiles, EMPTY_FILTERS.distanceMiles)
    );
  }, [filters]);

  return { filters, updateFilter, resetFilters, hasActiveFilters };
}
